import React from 'react';
import Form from 'react-bootstrap/Form';
import LzFormFieldBase from './_base';

class LzFormFieldInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value ? props.value : '',
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { value } = this.props;

        // If value changed then apply it to state
        if (typeof value !== 'undefined' && value !== prevProps.value) {
            this.setState({ value: value });
        }
    }

    onChange(val) {
        const { name, onChange } = this.props;

        this.setState({ value: val });

        if (onChange) {
            onChange(name, val);
        }
    }

    render() {
        const { value } = this.state;
        const { fluid, required, disabled, hasError, errorMessage, icon, className, style, id, name, label, type, placeholder, hint, disableAutocomplete } = this.props;

        const theName = name ? name : '';
        const theId = id ? id : 'id_' + theName;

        const autoComplete = disableAutocomplete || 'password' === type ? 'new-password' : 'on';

        return (
            <LzFormFieldBase
                id={theId}
                fluid={fluid}
                required={required}
                icon={icon}
                name={name}
                label={label}
                hint={hasError ? '' : (hint || placeholder || '')}
                errorMessage={hasError ? errorMessage : ''}
            >

                <Form.Control
                    isInvalid={hasError}
                    required={required}
                    disabled={disabled}
                    type={type || 'text'}
                    name={name || ''}
                    className={'lz-input ' + (className ? className : '')}
                    style={style || {}}
                    placeholder={placeholder || ''}
                    autoComplete={autoComplete}
                    value={value}
                    onChange={(evt) => this.onChange(evt.target.value)}
                />

            </LzFormFieldBase>
        );
    }

}

export default LzFormFieldInput;
